// WARNING: this file is AUTOGENERATED, only main.ts and index.ts are editable
// rerun yarn generate:enums to update

import { getInflectionTypeById } from 'app/constants/enums/InflectionType/main';

/* eslint-disable max-len */
export const PLURAL = getInflectionTypeById('plural');
/* eslint-enable max-len */
